<div [class]="className">
  <ng-content select="[sectionIcon]"></ng-content>
  <ng-content select="[sectionIconTitle]"></ng-content>
  <ng-content select="[sectionIconDescription]"></ng-content>
</div>
